<div class="header">
  <si-calendar-direction-button
    direction="left"
    [ariaLabel]="previousLabel()"
    [disabled]="isPreviousButtonDisabled()"
    (clicked)="setYearOffset(-1)"
  />
  <button
    type="button"
    class="open-year-view flex-fill mx-4 btn btn-tertiary calendar-button"
    (click)="emitViewChange()"
  >
    {{ focusedDate() | date: 'yyyy' }}
  </button>
  <si-calendar-direction-button
    direction="right"
    [ariaLabel]="nextLabel()"
    [disabled]="isNextButtonDisabled()"
    (clicked)="setYearOffset(1)"
  />
</div>
<div class="calendar-table">
  <table class="px-9" role="grid">
    <tbody
      si-calendar-body
      [focusedDate]="focusedDate()"
      [compareAdapter]="compareAdapter"
      [startDate]="startDate()"
      [endDate]="endDate()"
      [enableRangeSelection]="isRangeSelection()"
      [previewRange]="previewRange()"
      [rows]="monthCells"
      [activeHover]="activeHover()"
      (activeHoverChange)="onActiveHoverChange($event)"
      (selectedValueChange)="emitSelectedValue($event)"
      (focusedDateChange)="emitFocusedDate($event)"
      (keydown)="calendarBodyKeyDown($event)"
    >
    </tbody>
  </table>
</div>
<div class="footer"></div>
